// en.js
export default {
  stallQualification: {
    title: "Stall qualification review",
    gateHint: "All stalls must submit materials and pass review before opening. Existing orders can still be fulfilled.",
    refresh: "Refresh",
    stallName: "Stall name",
    stallAddress: "Stall address",
    nightMarket: "Night market ID",
    status: "Application status",
    canOpen: "Materials approved",
    yes: "Yes",
    no: "No",
    draft: "Draft",
    pending: "Pending review",
    approved: "Approved",
    rejected: "Rejected",
    notSubmitted: "Not submitted",
    unknown: "Not loaded",
    responsibleName: "Responsible person",
    contactPhone: "Contact phone",
    identityNumber: "Identity number",
    email: "Email",
    stallIntroduction: "Stall introduction",
    bankAccountName: "Bank account holder",
    bankName: "Bank name",
    bankAccountNo: "Bank account number",
    bankProofImages: "Bank account proof",
    businessRegistrationImages: "Business registration proof (if available)",
    directorScreenshotImages: "Director records screenshot (if available)",
    uboDeclarationImages: "Beneficial owner declaration (if available)",
    identityImages: "Identity photos",
    stallImages: "Stall photos",
    foodRegistrationNumber: "Food business registration number",
    foodRegistrationImages: "Food business registration proof",
    foodPolicyHint: "Food business registration number and proof are optional.",
    saveDraft: "Save draft",
    submit: "Submit for review",
    history: "Application history",
    version: "Application version",
    submittedAt: "Submitted at",
    reviewedAt: "Reviewed at",
    rejectReason: "Rejection reason",
    actions: "Actions",
    detail: "View details",
    upload: "Upload image",
    uploadHint: "JPEG / PNG, up to 5 MB each and 5 images per group.",
    remove: "Remove",
    failed: "Operation failed. Please try again.",
    materialsRequired: "Complete the responsible person, identity, stall photos and bank account details.",
    submitted: "Submitted for review",
    saved: "Draft saved",
    storeId: "Stall ID",
    search: "Search",
    submittedBy: "Submitted by (ID)",
    reviewedBy: "Reviewed by (ID)",
    reasonPlaceholder: "A reason is required for rejection (up to 500 characters)",
    approve: "Approve",
    reject: "Reject",
    reasonRequired: "Enter a rejection reason.",
    reviewed: "Review saved"
  },
	dongtai:{
		Unaccepted:'Unaccepted',
		Accepted:'Accepted',
		Mealalreadyserved:'Meal already served',
		RefundAftersales:'Refund/After sales'
	},
	loding:{
		language:'en',
		lass:'en',
		cte:'CTE-COOPERATE',
		lang:'language',
		username:'username',
		pasd:'password',
		logng:'log on',
		txuse:'Please fill in your username',
		txpad:'Please fill in the password'
	},
	route: {
		cte:'CTE',
		home:'home',
		mdguanli:'Store Management',
		mdlist:'Store List',
		mdfenlei:'CATEGORY',
		spguanli:'product control',
		biaoti: 'Welcome to CTE-COOPERATE',
		degnlu: 'exit',
		qttuicu: 'Are you sure you want to log out?',
		tishi:'prompt',
		tued:'determine',
		quxiao:'cancellation',
		yuiquangl: 'Coupon Management',
		zxhd: 'Promotion Management',
		quanyi: 'Available Coupons',
		ddpl:'Order Review',
    },
	index:{
		newdd:'Latest orders',
		ddid:'Order No.',
		invoice: 'Invoice',
		invoiceNone: 'None',
		invoiceIssued: 'Issued',
		invalidBtn: 'Void',
		invalidReason: 'Void Reason',
		invalidOk: 'Voided',
		cretim:'Order time',
		amount:'Amount',
		address:'Shipping address',
		jvli:'Delivery distance',
		ddodr:'commodity',
		type:'type',
		tangs:'Dine in',
		ziqu:'ask for',
		waisong:'takeaway',
		collectPayment:'cash on delivery',
		yes:'yes',
		nos:'no',
		right:'operate',
		chak:'view',
		jiedan:'accept',
		chucan:'Dining out',
		tishi:'prompt',
		tisiyu:'Are you sure you want to process the order?',
		quxiao:'cancellation',
		qued:'determine',
		xiangq:'details',
		freight:'Delivery fee',
		qishou:'Order taking rider',
		foods:'commodity',
		guanbi:'close',
		shus:'Merchant',
		sqsu:'rider',
		user:'user',
		dpshu:'Number of stores',
		ddsour:'Daily income',
		dddingd:'Same day order',
		zongsr:'Total income',
		zddlng:'Total order quantity',
		ketixan:'Withdrawable amount',
		beizu:'notes',
		cxhdxx: "Promotion Information",
		ptcxhd: "Platform Promotions",
		sjcxhd: "Merchant Promotions",
		jm: "Discount/Deduction",
		yhqxx: "Coupon Information",
		ptyhq: "Platform Coupons",
		sjyhq: "Merchant Coupons",
		yhje: "Discount Amount",
		none:"None",
		export: 'Export',
		jfsyqk: 'Points Utilization',
		jfsysl: 'Points Consumed',
		jfdkje: 'Deducted Amount',
		startTime: 'Start Time',
		endTime: 'End Time',
		payType: 'Payment method',
		CashOnDelivery: 'Cash on delivery',
		OfflineTransfer: 'Transfer Payment',
		OMG: 'OMG',
		LinePay: 'Line Pay',
		cash: 'Cash'
	},
	mendian:{
		UBN: 'UBN',
		EnterUBN: 'Enter UBN',
		UBNFormatError: 'UBN must be 8 digits',
		home:'home',
		Management:'Store Management',
		StoreList:'Store List',
		AddStore:'Add Store',
		logo:'logo',
		StoreCover:'Store Cover',
		StoreName:'Store Name',
		Startingprice:'Minimum delivery price',
		openBusiness:'Open For Business',
		windingUp:'winding-up',
		area:'area',
		Telephone:'Service phone number',
		operate:'operate',
		modify:'modify',
		delete:'delete',
		Enterstorename:'Please enter the store name',
		address:'address',
		InputAddress:'Please enter the store address',
		coordinate:'coordinate',
		Positioningobtaincoordinates:'Please click on the location icon to obtain the store coordinates',
		Storetype:'Store type',
		Restaurant:'Restaurant',
		Supermarket:'Supermarket',
		Fillintheprice:'Fill in the minimum delivery price',
		Fillphonenumber:'Fill in customer service phone number',
		FillopenBusiness:'Fill in the start time of business, for example: 8:00',
		FillwindingUp:'Fill in the closing time, for example: 18:00',
		classification:'classification',
		Pleaseselect:'Please select',
		ServiceType:'Service Type',
		Fooddelivery:'Food delivery',
		Dinein:'Dine in',
		Selfpickuptakeout:'Self pickup of takeout',
		Summericedrink:'Summer ice drink',
		Exquisiteafternoontea:'Exquisite afternoon tea',
		state:'state',
		trade:'trade',
		close:'close',
		determine:'determine',
		cancellation:'cancellation',
		selectaddress:'select address',
		Covercannotempty:'Store cover cannot be empty',
		Namecannotempty:'Store name cannot be empty',
		Addresscannotempty:'Store address cannot be empty',
		Coordinatescannotempty:'Coordinates cannot be empty',
		openBusinesscannotempty:'The opening hours cannot be empty',
		windingUpcannotempty:'The closing time cannot be empty',
		Classifiedmandatory:'Classified as mandatory',
		Selectservicetype:'At least one service type must be selected',
		prompt:'prompt',
		youwanttodeleteit:'Are you sure you want to delete this store?',
		successful:'Delete successful',
		Deletefailed:'Failed, please try again',
		undelete:'Cancelled deletion',
		ModifyStore:'Modify Store',
		Selectmapobtainaddress:'Please click on the map to obtain the address',
		ItcanonlyJPG:'Uploading avatar images can only be in JPG format!',
		Cannotexceed:'The size of the uploaded avatar image cannot exceed 2MB!',
		SearchAddress:'Search Address',
		Pleasekeywords:'Please enter keywords',
		currentlocation:'current location',
		openingtime: 'Business Hours',
		addTime: 'Add Time Slot',
		zssjd: 'Please add at least one operating time slot',
		mgsjd: 'Each time slot must have both start and end time',
		menuPhoto: 'Menu Photo',
		menuPhoto2: 'Please upload a menu photo'
	},
	fenlei:{
		home:'home',
		Management:'Store Management',
		CATEGORY:'CATEGORY',
		Addcategory:'Add product category',
		Classiname:'Classification name',
		operate:'operate',
		modify:'modify',
		delete:'delete',
		Plearname:'Please enter the category name',
		determine:'determine',
		cancellation:'cancellation',
		Classifyempty:'Category name cannot be empty',
		successfully:'Submitted successfully!',
		Modifyclass:'Modify classification',
		prompt:'prompt',
		DeleteCategory:'Are you sure you want to delete this category?',
		successful:'Delete successful',
		Deletefailed:'Failed, please try again',
		undelete:'Cancelled deletion',
		id:'id',
		sodi:'Please enter the sorting ID, the larger the number, the higher it will be'
	},
	imageCrop: {
		title: 'Crop image',
		hint: 'Drag the crop area to move it, or drag the lower-right corner to resize it.',
		cancel: 'Cancel',
		confirm: 'Crop and upload',
		invalidType: 'Please select an image file.',
		tooLarge: 'Image size must not exceed {size} MB.',
		readFailed: 'Could not read the image. Please choose another one.',
		cropFailed: 'Could not crop the image. Please try again.',
		uploadFailed: 'Image upload failed.',
		networkFailed: 'Image upload failed. Check your network and try again.'
	},
	foots:{
		home:'home',
		Management:'Store Management',
		Commodityfood:'Commodity management',
		classification:'classification',
		addproduct:'add product',
		Tradename:'Trade name',
		Commoditypicture:'Commodity picture',
		commodityprice:'commodity price',
		illustrate:'illustrate',
		operate:'operate',
		modify:'modify',
		delete:'delete',
		Enterproductname:'Please enter the product name',
		Enterproductprice:'Please enter the product price',
		Attributes:'Attributes',
		AddType:'Add Type',
		Radio:'Radio',
		multiplechoice:'multiple choice',
		optional:'optional',
		required:'required',
		Introduction:'Product Introduction',
		EnterIntroduction:'Please enter the product description',
		Dorecommendit:'Do you recommend it',
		Productsorting:'Product sorting',
		Anynumber:'Fill in any numerical value, with values ranked first',
		determine:'determine',
		cancellation:'cancellation',
		typename:'type-name',
		InputMerchantType:'Please enter the product type',
		Multiplechoices:'Do you want to select multiple options',
		Isitmandatory:'Is it mandatory',
		Addspecifications:'Add specifications',
		formname:'form name',
		Entercationname:'Please enter the specification name',
		Specificationprice:'Specification price',
		Enterandprices:'Please enter the specification price',
		description:'description',
		Entercationiption:'Please enter the specification description',
		Imagebeempty:'The image cannot be empty',
		Namebeempty:'Name cannot be empty',
		Pricebeempty:'Price cannot be empty',
		Thenamebeempty:'The specification name cannot be empty',
		Typenamebeempty:'Type name cannot be empty',
		prompt:'prompt',
		Confirmdeletion:'Are you sure you want to delete the product type?',
		Unabletodelete:'This type has specifications and cannot be deleted',
		DeleteSpecification:'Are you sure you want to delete the product specifications?',
		Modifyproduct:'Modify product',
		Deletethisproduct:'Are you sure you want to delete this product?',
		successful:'Delete successful',
		Deletefailed:'Failed, please try again',
		undelete:'Cancelled deletion',
		ItcanonlyJPG:'Uploading avatar images can only be in JPG format!',
		Cannotexceed:'The size of the uploaded avatar image cannot exceed 2MB!',
		search: 'Search',
		reset: 'Reset',
		AddCategoryFirst:'Please add a product category before adding products'
	},
	cuxiao: {
		home: 'Home',
		yuiquangl: 'Coupon Management',
		zxhd: 'Promotion Management',
		AddCX: 'Add New',
		hdmc: 'Promotion Name',
		hdmcms: 'Please enter promotion name',
		hdhb: 'Promotion Poster',
		qmfs: 'Discount Type',
		qmyf: 'Shipping Fee',
		ddjdz: 'Order',
		ddjdk: 'Product',
		qmz: 'Discount Value',
		qmzsm: 'Leave blank for free shipping. For 30% discount enter 0.3. For 1000 deduction enter 1000',
		sytj: 'Usage Condition',
		sytjsm: 'Leave blank for no condition. Enter 1000 for minimum order amount of 1000',
		salesFund: 'Usage Limit',
		salesFundsm: 'Leave blank for unlimited use. Enter 1 for one-time use per user',
		endTime: 'End Date',
		endTimesm: 'Please select promotion end date',
		salesState: 'Promotion Status',
		salesStateKq: 'Active',
		salesStateTy: 'Inactive',
		illustrate: 'Description',
		illustratesm: 'Please enter description',
		jsrq: 'End Date',
		hdzt: 'Promotion Status',
		operate: 'Action',
		modify: 'Edit',
		delete: 'Delete',
		hdmcEpty: 'Promotion name cannot be empty',
		qmfsEmty: 'Discount type is required',
		endTimeEmty: "End date is required",
		salesStateEmty: "Promotion status is required",
		salesReductionEmty: "Discount value is required",
		salesReduction0: "Order/Product discount value must be greater than 0",
		delSm: 'Are you sure you want to delete this record?',
		ItcanonlyJPG: 'Only JPG format images can be uploaded!',
		Cannotexceed: 'Image size cannot exceed 2MB!',
		bnxg:'This promotion has been used by customers; only the status can be modified, while other core fields remain unchangeable',
	},
	quanyi: {
		kyyhq: 'Available Coupons',
		add: 'Add New',
		yhmc: 'Coupon Name',
		yhfs: 'Discount Type',
		sm: 'Description',
		sytj: 'Usage Condition',
		zt: 'Status',
		qy: 'Enable',
		gb: 'Disable',
		yhqlx1: 'Shipping Fee',
		yhqlx2: 'Order',
		yhqlx3: 'Product',
		yhqlx4: 'Specific Item Discount',
		total: 'Total Coupons',
		creatTime: 'Creation Date',
		sryhmc: 'Please enter coupon name',
		yhnum: 'Discount Value',
		sryhnum: 'Enter 0 for free shipping, 0.7 for 30% discount , or 1000 for 1000 unit deduction',
		yhmnum0: 'Order/Product discount value must be greater than 0',
		srtotal: 'Please enter total number of coupons',
		lqxz: 'Claim Limit Per User',
		srlqxz: 'Please enter claim limit per user',
		validity: "Validity Period (Days)",
		srvalidity: 'Please enter validity period',
		shuoming: 'Description',
		srshuoming: 'Please enter description',
		tiaojian: 'Usage Condition',
		srtiaojian: 'Enter usage condition. 0 means no minimum. >0 means minimum spend amount',
		nameEpty: 'Coupon name cannot be empty',
		yhfangsEmpty: 'Please select discount type',
		yhnumEmty: 'Discount value cannot be empty',
		totalEmty: 'Total coupons cannot be empty',
		lqxzEmty: 'Claim limit per user cannot be empty',
		validityEmty: 'Validity period cannot be empty',
		stateEmty: 'Please select status',
		xcsp: 'Select Products',
		qxcsp: 'Please select products',
		md: "Store:",
		xcmd: "Select Store",
		spfl: 'Product Category:',
		spmc: 'Product Name:',
		cx: 'Search',
		tp: 'Image',
		jg: 'Price',
		qx: 'Cancel',
		qd: 'Confirm',
		ItcanonlyJPG: 'Only JPG format images can be uploaded!',
		Cannotexceed: 'Image size cannot exceed 2MB!',
		bnxg:'This coupon has been redeemed. Only status can be modified; core fields are locked.',
		claimedCount:'Claimed Quantity',
	},
	review:{
		ddid:'Order ID',
		srddid:'Enter order ID',
		plsj:'Review time',
		cz:'Action',
		sc:'Delete',
		ck:'View',
		yhid:'User ID',
		pf:'Rating',
		plnr:'Review content',
		sfnm:'Anonymous',
		yes:'Yes',
		no:'No',
		pltp:'Review images',
		ddpl:'Order review',
	},
TableQRCode: {
		text1: 'Type',
		text2: 'All',
		text3: 'Private QR Code',
		text4: 'Public QR Code',
		text5: 'Status',
		text6: 'Enabled',
		text7: 'Disabled',
		text8: 'Search',
		text9: 'Create Table QR Code',
		text10: 'Table Number',
		text11: 'Disabled',
		text12: 'Store/Stall',
		text13: 'Usage Status',
		text14: 'Available',
		text15: 'In Use',
		text16: 'Activation Status',
		text17: 'Created At',
		text18: 'Actions',
		text19: 'View QR Code',
		text20: 'Edit',
		text21: 'Delete',
		text22: 'Table Number',
		text23: 'Enter a table number, e.g. A01',
		text24: 'Select a store/stall',
		text25: 'Notes',
		text26: 'Enter notes',
		text27: 'Cancel',
		text28: 'Confirm',
		text29: 'Select Store/Stall',
		text30: 'Search by stall name or address',
		text31: 'Store/Stall Name',
		text32: 'Address',
		text33: 'Phone',
		text34: 'Table QR Code',
		text35: 'Table Number: ',
		text36: 'Loading...',
		text37: 'Close',
		text38: 'Download',
		text39: 'Enter a table number',
		text40: 'Select a type',
		text41: 'Select a stall',
		text42: 'Failed to load the list',
		text43: 'Edit Table QR Code',
		text44: 'Updated successfully',
		text45: 'Update failed',
		text46: 'Created successfully',
		text47: 'Create failed',
		text48: 'Are you sure you want to delete this table QR code?',
		text49: 'Notice',
		text50: 'Deleted successfully',
		text51: 'Delete failed',
		text52: 'Operation successful',
		text53: 'Operation failed',
		text54: 'Failed to load the QR code',
		text55: 'Orders',
		text56: 'Table Orders - ',
		text57: 'Order Status',
		text58: 'Pending',
		text59: 'In Progress',
		text60: 'Completed/Closed',
		text61: 'Order No.',
		text62: 'Amount',
		text63: 'Meal Preparation Status',
		text64: 'Order Placed At',
		text65: 'Prepared',
		text66: 'Not Prepared',
		text67: 'Paid',
		text68: 'Order Accepted',
		text69: 'Out for Delivery',
		text70: 'Delivered',
		text71: 'Cancelled',
		text72: 'Refund in Progress',
		text73: 'Refunded',
		text74: 'Refund Rejected',
		text75: 'Reviewed',
		text76: 'Unknown',
		text77: 'Failed to load orders',
		text78: 'Awaiting Acceptance',
		text79: 'Preparing',
		text80: 'Preparation Complete',
		text81: 'Completed',
		text82: 'Notes',
		text83: 'Home',
		text84: 'Table QR Code Management',
	},
	StallManage: {
		ownerPassword: 'Password',
		editOwnerTitle: 'Edit Stall Owner',
		editOwnerPasswordKeep: 'Leave blank to keep the current password'
	},
	tableQrcode:{
		orderBtn:'Orders',
		orderDialogTitle:'Table Orders - ',
		orderStatus:'Order Status',
		orderAll:'All',
		orderPending:'Pending',
		orderInProgress:'In Progress',
		orderCompleted:'Completed/Closed',
		orderNo:'Order No.',
		orderAmount:'Amount',
		orderState:'Order Status',
		diningStatus:'Dining Status',
		orderTime:'Order Time',
		diningDone:'Served',
		diningNotDone:'Not Served',
		state0:'Pending',
		state1:'Paid',
		state2:'Accepted',
		state3:'Delivering',
		state4:'Delivered',
		state6:'Cancelled',
		state7:'Refunding',
		state8:'Refunded',
		state9:'Refund Rejected',
		state11:'Reviewed',
		stateUnknown:'Unknown',
		getOrderFailed:'Failed to get orders',
	}
,
		subaccount: {
			menu: 'Managed Accounts',
			title: 'Managed Account Management',
			description: 'Assign one account to multiple stores without switching an active store.',
			create: 'Add Managed Account',
			name: 'Name',
			phone: 'Phone',
			stores: 'Assigned Stores',
			noStores: 'No assigned stores',
			accountStatus: 'Account Status',
			ownerEnabled: 'Enabled by owner',
			ownerDisabled: 'Disabled by owner',
			platformEnabled: 'Platform active',
			platformDisabled: 'Disabled by platform',
			online: 'Online Status',
			onlineYes: 'Online',
			onlineNo: 'Offline',
			lastLogin: 'Last Login',
			actions: 'Actions',
			edit: 'Edit',
			resetPassword: 'Reset Password',
			disableOwner: 'Disable',
			enableOwner: 'Enable',
			editTitle: 'Edit Managed Account',
			createTitle: 'Add Managed Account',
			password: 'Password',
			namePlaceholder: 'Enter name',
			phonePlaceholder: 'Enter login phone',
			passwordPlaceholder: 'Enter password',
			storePlaceholder: 'Select assigned stores',
			platformDisabledHint: 'This account is disabled by the platform. Enabling it as owner will not remove the platform restriction.',
			cancel: 'Cancel',
			save: 'Save',
			nameRequired: 'Please enter a name',
			phoneRequired: 'Please enter a phone number',
			passwordRequired: 'Please enter a password',
			storeRequired: 'Please select at least one store',
			saved: 'Saved successfully',
			resetPasswordTitle: 'Reset Managed Account Password',
			newPassword: 'New Password',
			confirmReset: 'Confirm Reset',
			passwordReset: 'Password reset; previous sessions have been revoked.',
			ownerEnabledResult: 'Set to enabled by owner',
			ownerDisabledResult: 'Set to disabled by owner',
			platformStillDisabled: 'The platform restriction is still active'
		},
		promoMenu: {
			title: 'Marketing',
			activity: 'Promotions',
			coupon: 'Coupons'
		},
		promoActivity: {
			home: 'Home',
			marketing: 'Marketing',
			title: 'Promotions',
			all: 'All',
			notStarted: 'Not Started',
			ongoing: 'Ongoing',
			ended: 'Ended',
			addActivity: 'Create Activity',
			activityName: 'Activity Name',
			activityType: 'Activity Type',
			typeManjian: 'Full Reduction',
			typeZhekou: 'Discount Products',
			typeHalfPrice: 'Half Price',
			typeNewUser: 'New Customer',
			status: 'Status',
			startTime: 'Start Time',
			endTime: 'End Time',
			operate: 'Operate',
			endBtn: 'End',
			tabManjian: 'Full Reduction',
			pleaseInputName: 'Please enter activity name',
			activityTime: 'Activity Time',
			ruleTiers: 'Rule Tiers',
			full: 'Full',
			fullAmount: 'Amount',
			reduce: 'Reduce',
			reduceAmount: 'Reduction Amount',
			yuan: 'Yuan',
			deleteTier: 'Delete',
			addTier: 'Add Tier',
			tabZhekou: 'Discount Products',
			discountRate: 'Discount Rate',
			productName: 'Product Name',
			productPrice: 'Price',
			remove: 'Remove',
			addProduct: 'Add Product',
			tabHalfPrice: 'Half Price',
			productImage: 'Image',
			selectProduct: 'Select Product',
			tabNewUser: 'New Customer',
			save: 'Save',
			cancel: 'Cancel',
			category: 'Category',
			selectCategory: 'Select Category',
			keyword: 'Keyword',
			search: 'Search',
			add: 'Add',
			endConfirm: 'Confirm to end this activity? It cannot be recovered.',
			prompt: 'Prompt',
			confirm: 'Confirm',
			productExists: 'Product already exists',
			pleaseSelectTime: 'Please select activity time',
			pleaseCompleteRules: 'Please complete the rules',
			pleaseCompleteDiscount: 'Please enter discount rate',
			pleaseSelectProducts: 'Please select products',
			pleaseInputReduce: 'Please enter reduction amount',
			addSuccess: 'Created successfully',
			operateSuccess: 'Operation successful',
			operateFail: 'Operation failed',
			editBtn: 'Edit',
			deleteBtn: 'Delete',
			editActivity: 'Edit Activity',
			createActivity: 'Create Activity',
			deleteConfirm: 'Confirm to delete this activity? It cannot be recovered.',
			editSuccess: 'Updated successfully',
			deleteSuccess: 'Deleted successfully',
			alreadyAdded: 'Already Added',
			discountedPrice: 'Discounted Price',
			originalPrice: 'Original Price',
			addDiscountProduct: 'Add Discount Product',
			productAlreadyAdded: 'Product already added',
			discountRateRange: 'Discount rate range 10%-99%',
			pleaseSelectProduct: 'Please select products first'
		},
		couponBatch: {
			pageTitle: 'Coupon Management', createBtn: 'Create Coupon', offShelfBtn: 'Off Shelf',
			offShelfConfirm: 'Confirm to off-shelf this coupon? Already claimed coupons can still be used.', couponName: 'Coupon Name',
			couponType: 'Coupon Type', totalCount: 'Total Count', remainCount: 'Remaining', receivedCount: 'Received',
			validDays: 'Valid Days', validDaysUnit: 'days (calculated after claim)', receiveTime: 'Claim Time',
			status: 'Status', statusAll: 'All', statusNotStarted: 'Not Started', statusActive: 'Active',
			statusEnded: 'Ended', statusOffShelf: 'Off Shelf', typeManjian: 'Full Reduction', typeProduct: 'Product Coupon',
			mutexLabel: 'Stacking', mutexShare: 'Shareable (can be stacked with promotions)', mutexExclusive: 'Exclusive (cannot be stacked with promotions)',
			threshold: 'Usage Threshold', thresholdUnit: 'Yuan', amount: 'Reduction Amount', amountUnit: 'Yuan',
			selectProduct: 'Select Product', discountRate: 'Discount Rate', discountRateUnit: '% (e.g., 70 for 30% off)',
			saveBtn: 'Save', cancelBtn: 'Cancel', storeLabel: 'Store', timeRange: 'Claim Time',
			nameRequired: 'Please enter coupon name', timeRequired: 'Please select claim time',
			totalRequired: 'Please enter total count', validDaysRequired: 'Please enter valid days', amountRequired: 'Please enter amount',
			marketing: 'Marketing',
			startTime: 'Start Time',
			endTime: 'End Time',
			days: 'days',
			offShelfSuccess: 'Off-shelf successfully',
			offShelfFail: 'Off-shelf failed',
			couponNamePlaceholder: 'Enter coupon name',
			selectStore: 'Select store',
			typeRequired: 'Please select coupon type',
			storeRequired: 'Please select store',
			thresholdRequired: 'Please enter threshold',
			discountRequired: 'Please enter discount rate',
			productRequired: 'Please select product',
			addSuccess: 'Created successfully',
			addFail: 'Creation failed',
			category: 'Category',
			selectCategory: 'Select category',
			keyword: 'Search',
			productName: 'Product Name',
			search: 'Search',
			image: 'Image',
			price: 'Price',
			add: 'Add',
			editBtn: 'Edit',
			deleteBtn: 'Delete',
			editCoupon: 'Edit Coupon',
			createCoupon: 'Create Coupon',
			deleteConfirm: 'Confirm delete this coupon? This cannot be undone.',
			typeFreeDelivery: 'Free Delivery',
			deleteSuccess: 'Deleted successfully',
			deleteFail: 'Delete failed',
			editSuccess: 'Updated successfully',
			editFail: 'Update failed',
			remove: 'Remove',
			productExists: 'Product already added',
			alreadyAdded: 'Added'
		},
		menuCopy: {
			entry: 'Copy from another store',
			title: 'Copy products',
			description: 'The current store is the target. Select a source store to preview category and product differences.',
			targetStore: 'Target store',
			sourceStore: 'Source store',
			selectSource: 'Select a source store',
			addedCategories: 'New categories',
			mergedCategories: 'Merged categories',
			addedProducts: 'New products',
			identicalProducts: 'Unchanged',
			differentProducts: 'Different products',
			alreadySynced: 'The menus are already identical. Nothing needs to be copied.',
			differenceDetails: 'Difference details',
			changedField: 'Field',
			targetValue: 'Current target value',
			sourceValue: 'Source value',
			conflictStrategy: 'Handle differences',
			keepTarget: 'Keep target version',
			overwriteTarget: 'Overwrite with source version',
			overwriteWarning: 'Overwrite updates product content and specification links only. Target availability and review status are preserved.',
			cancel: 'Cancel',
			confirm: 'Copy products',
			operationFailed: 'The operation failed. Please try again.',
			successSummary: 'Copy complete: {categories} categories and {products} products added, {skipped} skipped, {overwritten} overwritten.',
			emptyValue: 'Empty',
			fieldNames: {
				price: 'Price', image: 'Image', introduce: 'Description', foodSku: 'Attributes', sort: 'Sort order', recommend: 'Recommended', specs: 'Specifications'
			},
			languages: { '0': 'Vietnamese', '1': 'English', '2': 'Simplified Chinese', '3': 'Traditional Chinese' }
		},

	Aside: {
		selfDeliverySettings: 'Self-Delivery Settings'
	},

	payMethod: {
		remarkTitle: 'Payment method notes',
		pageTitle: 'Payment Settings',
		methodSectionTitle: 'Accepted Payment Methods',
		methodTip: 'If nothing is checked, all available payment methods are accepted. Methods disabled by the platform are unavailable to both sides.',
		save: 'Save',
		saveSuccess: 'Saved',
		cancel: 'Cancel',
		groupCod: 'Cash on Delivery',
		groupCash: 'Cash',
		groupCard: 'Credit Card / Apple Pay',
		groupLinePay: 'LINE Pay',
		groupOffline: 'Offline Transfer',
		bankSectionTitle: 'Bank Cards for Receiving',
		bankTip: 'Payers can only see the active card. Activating a new card deactivates the previous one. Offline transfer requires at least one active card.',
		bankName: 'Bank',
		accountNo: 'Account No.',
		accountName: 'Account Name',
		activeState: 'Status',
		active: 'Active',
		inactive: 'Inactive',
		action: 'Actions',
		enable: 'Activate',
		edit: 'Edit',
		delete: 'Delete',
		addCard: 'Add Card',
		editCard: 'Edit Card',
		pleaseSelectBank: 'Select a bank',
		deleteConfirm: 'Delete this bank card?',
		tip: 'Notice',
		cashScopeHint: 'Available for pickup & dine-in orders only',
		notReadyTip: 'Methods that are not ready stay hidden from customers even when ticked. Credit card / LINE Pay require platform-side credentials; offline transfer requires at least one active bank card.',
		notReadyTag: 'Not ready',
	},
	selfDelivery: {
		menu: 'Self-Delivery Settings',
		pageTitle: 'Self-Delivery Settings',
		effectTip: 'This setting applies to all stalls in the night market: delivery orders placed within the configured time slots bypass the rider pool and are delivered by the night market itself; other orders are still delivered by riders.',
		enableSwitch: 'Enable self-delivery',
		modeLabel: 'Delivery Mode',
		modeAllDay: 'All day',
		modeCustom: 'Custom time slots',
		customTip: 'Set time slots by weekday; a slot includes its start time and excludes its end time',
		addRange: 'Add slot',
		removeRange: 'Remove',
		startTime: 'Start',
		endTime: 'End',
		monday: 'Monday',
		tuesday: 'Tuesday',
		wednesday: 'Wednesday',
		thursday: 'Thursday',
		friday: 'Friday',
		saturday: 'Saturday',
		sunday: 'Sunday',
		saveBtn: 'Save',
		saveSuccess: 'Saved successfully',
		loadFail: 'Failed to load settings',
		saveFail: 'Failed to save',
		invalidRange: 'Some time slots are incomplete, or the end time is not later than the start time',
		noRangeTip: 'At least one time slot is required in custom mode',
		freightBilling: 'Self-delivery freight'
	}
}
